import { render, staticRenderFns } from "./ao.vue?vue&type=template&id=0021b3cc&scoped=true&"
import script from "./ao.vue?vue&type=script&lang=js&"
export * from "./ao.vue?vue&type=script&lang=js&"
import style0 from "./ao.vue?vue&type=style&index=0&id=0021b3cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021b3cc",
  null
  
)

export default component.exports